import { render, staticRenderFns } from "./RecordListFilter.vue?vue&type=template&id=2aa1f45b&scoped=true&"
import script from "./RecordListFilter.vue?vue&type=script&lang=js&"
export * from "./RecordListFilter.vue?vue&type=script&lang=js&"
import style0 from "./RecordListFilter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RecordListFilter.vue?vue&type=style&index=1&id=2aa1f45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1f45b",
  null
  
)

export default component.exports